export default "__VITE_ASSET__C$vc7eps__"